import { render } from "./CategoryForm.vue?vue&type=template&id=5b8736c5&scoped=true&ts=true"
import script from "./CategoryForm.vue?vue&type=script&lang=ts"
export * from "./CategoryForm.vue?vue&type=script&lang=ts"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b8736c5"]])

export default __exports__